import { useState } from "react";
import { Ellipsis, Pencil, Trash2 } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import useAuthorized from "hooks/useAuthorized";
import { invalidateCampaignStatusesQuery } from "hooks/useCampaignStatusesTable";
import DeleteCampaignStatusModal from "routes/campaign_status/components/DeleteCampaignStatusModal";
import EditCampaignStatusModal from "routes/campaign_status/components/EditCampaignStatusModal";

export function CampaignStatusesTableActions({ original }) {
  const canEdit = useAuthorized([ACL_RELATIONSHIPS.campaignStatus.edit]);
  const canDelete = useAuthorized([ACL_RELATIONSHIPS.campaignStatus.delete]);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  if (!canEdit && !canDelete) {
    return null;
  }

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          aria-label="Campaign status actions"
          className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
        >
          <Ellipsis />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="tw:w-auto">
          {canEdit && (
            <DropdownMenuItem onClick={() => setEditOpen(true)}>
              <Pencil />
              Edit
            </DropdownMenuItem>
          )}
          {canDelete && (
            <DropdownMenuItem
              variant="destructive"
              onClick={() => setDeleteOpen(true)}
            >
              <Trash2 />
              Delete
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      <EditCampaignStatusModal
        campaignStatus={original}
        open={editOpen}
        onOpenChange={setEditOpen}
        fetchStatuses={invalidateCampaignStatusesQuery}
      />
      <DeleteCampaignStatusModal
        campaignStatus={original}
        open={deleteOpen}
        onOpenChange={setDeleteOpen}
        fetchStatuses={invalidateCampaignStatusesQuery}
      />
    </>
  );
}
